/**
 * 確認ダイアログ
 *************************************************/
import moment from 'moment';
import React, { FC } from 'react';
import { Confirm, Transition } from 'semantic-ui-react';

export interface confirmDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  action: () => void | Promise<void>;
  currentPage: 'example' | 'question';
  timeLimit?: number;
  categoryNo?: number;
}
const ConfirmDialog: FC<confirmDialogProps> = ({ isOpen, setIsOpen, action, currentPage, timeLimit, categoryNo }) => {
  let dialogTitle: string;
  let dialogMessage: string;
  if (currentPage === 'example') {
    dialogTitle = '問題へ進む';
    dialogMessage = `問題へ進んでもよろしいですか？<br/>制限時間は${moment(timeLimit).format('m分')}です`;
  } else if (categoryNo === 5) {
    dialogTitle = '試験終了';
    dialogMessage = '適性検査試験を終了します、よろしいでしょうか？';
  } else {
    dialogTitle = '次の問題へ進む';
    dialogMessage = '次の問題へ進んでもよろしいですか？';
  }

  return (
    <>
      <Transition visible={isOpen} animation="fade up" duration={500}>
        <Confirm
          header={dialogTitle}
          content={() => {
            return (
              <p
                style={{ padding: '20px', fontSize: '1.2rem' }}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: dialogMessage,
                }}
              />
            );
          }}
          open={isOpen}
          onCancel={() => setIsOpen(false)}
          onConfirm={action}
          size="tiny"
          data-cy="confirm-dialog"
        />
      </Transition>
    </>
  );
};
export default ConfirmDialog;
